module.exports = __webpack_public_path__ + "img/img-point-experiment-board.c0cb0a59.svg";